@if (componentData.data$ | async; as component) {
  <div class="container">
    <div class="row">
      <boels-banner-markup-media-container
        [class.pb-0]="component.removeBottomSpacing | safeCheck"
        [removeGradient]="component?.removeGradient | safeCheck"
        [withImage]="component?.media"
        [bannerComponent]="component"
        [bannerType]="bannerType"
      ></boels-banner-markup-media-container>
    </div>
  </div>
}
